

















import { Component, Prop, Vue } from 'vue-property-decorator';
import SelectorMessage from '@/models/selectorMessage';
import MessageType from '@/enums/messageType';

import iconError from '@/assets/images/icon-error.svg';
import iconWarning from '@/assets/images/icon-warning.svg';
import iconInfo from '@/assets/images/icon-info.svg';
import iconOk from '@/assets/images/icon-ok.svg';

@Component
export default class SelectorMessageItem extends Vue {
  @Prop({type: Object, required: true}) selectorMessage!: SelectorMessage;

  get iconSource() {
    switch (this.selectorMessage.messageType) {
      case MessageType.warning:
        return iconWarning;
      case MessageType.info:
        return iconInfo;
      case MessageType.success:
        return iconOk;
      default:
        return iconError;
    }
  }

  get iconAltText(): string {
    switch (this.selectorMessage.messageType) {
      case MessageType.warning:
        return 'Warning';
      case MessageType.info:
        return 'Information';
      case MessageType.success:
        return 'Success';
      default:
        return 'Error';
    }
  }
}
